import { WORK_PACKAGES } from './rows-work-packages.js';
export { WORK_PACKAGES };
/**
 * Case-insensitive lookup of a work-package id, returning its canonical spelling
 * (`p0-12` → `P0-12`). File names, branches and worktrees use lower case.
 */
export function canonicalWorkPackage(value) {
    const wanted = value.toLowerCase();
    return WORK_PACKAGES.find((id) => id.toLowerCase() === wanted);
}
/** True only for an id spelled exactly as in {@link WORK_PACKAGES}. */
export function isWorkPackageId(value) {
    return typeof value === 'string' && WORK_PACKAGES.includes(value);
}
//# sourceMappingURL=work-packages.js.map